import { render, staticRenderFns } from "./RiskManagementSystemPage.vue?vue&type=template&id=23b016c8&scoped=true"
import script from "./RiskManagementSystemPage.vue?vue&type=script&lang=js"
export * from "./RiskManagementSystemPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b016c8",
  null
  
)

export default component.exports